import React from 'react';

import NavigationBreadcrumbs from '../../Common/NavigationBreadcrumbs';
import { getBillingDashboardPageBreadcrumb } from '../Billing/BillingDashboardPage';
import { getInvoiceListPageBreadcrumb } from './InvoiceListPage';

import PageHeader from '../../Common/PageHeader';

import ProcessingIndicator from '../../Common/ProcessingIndicator';

import InvoicePanel from './InvoicePanel';

import { INVOICE_TYPE_ENUM } from '../../../Entities/Invoice';



class CarryoverInvoicePage extends React.Component {
  state = {
    pageInitializationComplete: false,
    pageInitializationErrors: [],
    invoiceNewMode: false,
    invoiceDownloadingState: false
  };

  facilityId;


  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);

    const facilityId = urlSearchParams.get('facility');
    this.facilityId = (facilityId !== null) ? facilityId : facilityId;

  }


  componentDidMount() {
    const initializationTasks = [];

    initializationTasks.push(new Promise((resolve, reject) => {
      this.setState({
        invoiceNewMode: true
      }, () => {
        resolve();
      });
    }));

    Promise.all(initializationTasks).then(() => {
      this.setState({
        pageInitializationComplete: true
      });
    }, errors => {
      this.setState({
        pageInitializationComplete: true,
        pageInitializationErrors: errors
      });
    });
  }


  handleInvoiceCreated = invoiceId => {
    window.location.href = `/wp-admin/admin.php?page=parkchirp_invoice&facility=${this.facilityId}&invoice=${invoiceId}`;
  }


  renderNavigationBreadcrumbs() {
    const breadcrumbs = [];
    breadcrumbs.push(getBillingDashboardPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getInvoiceListPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getCarryoverInvoicePageBreadcrumb());

    return (
      <NavigationBreadcrumbs breadcrumbs={breadcrumbs} />
    );
  }


  renderPageHeader() {
    const heading = 'New Carryover Invoice';
    const actions = [];

    return (
      <PageHeader heading={heading}
        actions={actions}
      />
    );
  }


  renderPageInitializationMessage() {
    const {
      pageInitializationComplete,
      pageInitializationErrors
    } = this.state;

    if (!pageInitializationComplete) {
      return (
        <div className="parkchirp--page--user-message-container">
          <ProcessingIndicator userMessage="Initializing, please wait..." />
        </div>
      );
    }

    if (pageInitializationErrors.length) {
      return (
        <div className="parkchirp--page--user-message-container">
          <div className="parkchirp--page--user-message">
            <p>The following errors occurred while initializing the page:</p>
            <ul>
              {pageInitializationErrors.map(error =>
                <li key={performance.now()}>{error}</li>
              )}
            </ul>
          </div>
        </div>
      );
    }
  }


  renderInvoice() {
    const {
      invoiceNewMode
    } = this.state;

    return (
      <InvoicePanel invoiceId={this.invoiceId}
        facilityId={this.facilityId}
        newMode={invoiceNewMode}
        onInvoiceCreated={this.handleInvoiceCreated}
        newInvoiceType={INVOICE_TYPE_ENUM.CARRYOVER_INVOICE}
      />
    );
  }


  render() {
    const {
      pageInitializationComplete,
      pageInitializationErrors
    } = this.state;

    return (
      <div className="parkchirp--page parkchirp--page--invoice-detail">
        {this.renderNavigationBreadcrumbs()}
        {this.renderPageHeader()}
        <div className="parkchirp--page-content">
          {(!pageInitializationComplete || pageInitializationErrors.length > 0) &&
            this.renderPageInitializationMessage()
          }
          {(pageInitializationComplete && pageInitializationErrors.length === 0) &&
            <div className="parkchirp--page--invoice-detail--main-content-container">
              {this.renderInvoice()}
            </div>
          }
        </div>
      </div>
    );
  }
}
export default CarryoverInvoicePage;


export function getCarryoverInvoicePageBreadcrumb(currentPage = true, facilityId = null) {
  const title = 'Invoice';
  const href = (currentPage) ? null :
    `?page=parkchirp_carryover_invoice${(facilityId !== null) ? `&facility=${facilityId}` : ''}`;

  return { title, href };
}